import React, { useState, useEffect } from 'react';
import Header from '../../ProjectCreation/Header2';
import "../../styles/SubCostline.css";
import back_arrow from "../../assets/svg/back-arrow.svg";
import { useNavigate, useLocation } from "react-router-dom";
import plus_icon from '../../assets/svg/plus_icon.svg'
import delete_icon from '../../assets/svg/delete_icon.svg'
import axiosInstance from '../../axiosInstance';
import AsyncSelect from 'react-select/async';
import CommonFooter from '../../CommonFooter/CommonFooter';

const SubCostlineViewPage = () =>  {
    const navigate = useNavigate();
    const [costElementName, setCostElementName] = useState("");
    const [totalAmount, setTotalAmount] = useState(0);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [elementOptions1, setElementOptions1] = useState([]);
    const [elementOptions2, setElementOptions2] = useState([]);
    const [selectedElement1, setSelectedElement1] = useState(null);
    const [selectedElement2, setSelectedElement2] = useState(null);
    const [quantitySetup, setQuantitySetup] = useState([]);
    const [rateSetup, setRateSetup] = useState([]);
    const location = useLocation();
    const [rows, setRows] = useState(() => {
        const navigationData = JSON.parse(sessionStorage.getItem('subcostNavigationData'));
        return navigationData?.existingRows || [{
            id: 1,
            description1: "",
            field1Type: "",
            field1Value: "",
            derivation: "",
            description2: "",
            field2Type: "",
            field2Value: "",
            linkValueAmount: "0.00",
            total: true,
            totalAmount: "0.00",
            value1: "",
            derivationOperator: "",
            value2: ""
        }];
    });

    useEffect(() => {
        if (!selectedRow) return;

        setRows(prevRows =>
            prevRows.map(row =>
                row.id === selectedRow.id ? selectedRow : row
            )
        );
    }, [selectedRow]);

    const loadElementOptions1 = async (inputValue) => {
        try {
            const res = await axiosInstance.get(
                `/costsolution/financial/element`,
                { params: { term: inputValue || '' } }
            );
            const elements = res.data?.element || [];
            const mapped = elements.map(item => ({
                label: item.element,  // Use 'element' as label
                value: item.id,        // Use 'id' as value
                elementValue: item.value
            }));
            setElementOptions1(mapped);
            return mapped;
        } catch (error) {
            console.error("Error loading element options:", error);
            return [];
        }
    };

    const loadElementOptions2 = async (inputValue) => {
        try {
            const res = await axiosInstance.get(
                `/costsolution/financial/element`,
                { params: { term: inputValue || '' } }
            );
            const elements = res.data?.element || [];
            const mapped = elements.map(item => ({
                label: item.element,  // Use 'element' as label
                value: item.id,       // Use 'id' as value
                elementValue: item.value
            }));
            setElementOptions2(mapped);
            return mapped;
        } catch (error) {
            console.error("Error loading element options:", error);
            return [];
        }
    };

    const loadCostTypeSuggestions = async (elementId, type) => {
        if (!elementId) return;

        try {
            const res = await axiosInstance.get(
                `/costsolution/costtype/autosuggestion/${elementId}`,
                { params: { term: '' } }
            );
            const costTypes = res.data?.autosuggestion || [];

            if (type === 1) {
                // Update cost type options for field 1
                setSelectedRow(prev => ({
                    ...prev,
                    costType1Options: costTypes.map(item => ({
                        label: item.label,
                        value: item.value,
                        costTypeValue: item.value
                    }))
                }));
            } else {
                // Update cost type options for field 2
                setSelectedRow(prev => ({
                    ...prev,
                    costType2Options: costTypes.map(item => ({
                        label: item.label,
                        value: item.value,
                        costTypeValue: item.value
                    }))
                }));
            }
        } catch (error) {
            console.error("Error loading cost type options:", error);
        }
    };

    useEffect(() => {
        if (!selectedRow) return;

        // Handle element1 value changes
        if (selectedRow.field1Type === "element" && selectedRow.element1) {
            const selectedElement = elementOptions1.find(opt => opt.value === selectedRow.element1.value);
            if (selectedElement) {
                setSelectedRow(prev => ({
                    ...prev,
                    field1Value: selectedElement.elementValue,
                    element1Value: selectedElement.elementValue
                }));
            }
        }

        // Handle element2 value changes
        if (selectedRow.field2Type === "element" && selectedRow.element2) {
            const selectedElement = elementOptions2.find(opt => opt.value === selectedRow.element2.value);
            if (selectedElement) {
                setSelectedRow(prev => ({
                    ...prev,
                    field2Value: selectedElement.elementValue,
                    element2Value: selectedElement.elementValue
                }));
            }
        }
    }, [selectedRow?.element1, selectedRow?.element2, elementOptions1, elementOptions2]);

    useEffect(() => {
        if (!selectedRow) return;

        const value1 = parseFloat(selectedRow.field1Value) || 0;
        const value2 = parseFloat(selectedRow.field2Value) || 0;

        let linkValue = 0;
        switch (selectedRow.derivationOperator) {
            case '+': linkValue = value1 + value2; break;
            case '-': linkValue = value1 - value2; break;
            case '*': linkValue = value1 * value2; break;
            case '/': linkValue = value2 !== 0 ? value1 / value2 : 0; break;
            default: linkValue = 0;
        }

        setSelectedRow(prev => ({
            ...prev,
            value1: value1.toFixed(2),
            value2: value2.toFixed(2),
            linkValueAmount: linkValue.toFixed(2)
        }));

    }, [
        selectedRow?.field1Value,
        selectedRow?.field2Value,
        selectedRow?.derivationOperator,
        selectedRow?.field1Type,
        selectedRow?.field2Type
    ]);



    useEffect(() => {
        const updatedRows = rows.map(row => {
            let value1 = 0;
            if (row.field1Type === "Numeric") {
                value1 = parseFloat(row.field1Value) || 0;
            } else if (row.field1Type === "link") {
                const linkedRow = rows.find(r => r.description1 === row.linkField1);
                value1 = linkedRow ? parseFloat(linkedRow.linkValueAmount) || 0 : 0;
                row.field1Value = value1.toString();
            } else if (row.field1Type === "element") {
                value1 = parseFloat(row.field1Value) || 0;
            }

            let value2 = 0;
            if (row.field2Type === "Numeric") {
                value2 = parseFloat(row.field2Value) || 0;
            } else if (row.field2Type === "link") {
                const linkedRow = rows.find(r => r.description1 === row.linkField2);
                value2 = linkedRow ? parseFloat(linkedRow.linkValueAmount) || 0 : 0;
                row.field2Value = value2.toString();
            } else if (row.field2Type === "element") {
                value2 = parseFloat(row.field2Value) || 0;
            }

            // Calculate link value
            let linkValue = 0;
            switch (row.derivationOperator) {
                case '+':
                    linkValue = value1 + value2;
                    break;
                case '-':
                    linkValue = value1 - value2;
                    break;
                case '*':
                    linkValue = value1 * value2;
                    break;
                case '/':
                    linkValue = value2 !== 0 ? value1 / value2 : 0;
                    break;
                default:
                    linkValue = 0;
            }

            return {
                ...row,
                value1: value1.toFixed(2),
                value2: value2.toFixed(2),
                linkValueAmount: linkValue.toFixed(2)
            };
        });

        if (JSON.stringify(updatedRows) !== JSON.stringify(rows)) {
            setRows(updatedRows);
        }

        const grandTotal = updatedRows
            .filter(row => row.total)
            .reduce((sum, row) => sum + parseFloat(row.linkValueAmount || 0), 0);

        setTotalAmount(grandTotal.toFixed(2));
    }, [rows]);


    const handleRowClick = (row) => {
        setSelectedRow({ ...row });

        setIsPopupOpen(true);
    };

    const handleClosePopup = () => {
        setIsPopupOpen(false);
    };

    const handleStopPropagation = (e) => {
        e.stopPropagation();
    };

    const handleAddRow = () => {
        const newRow = {
            id: rows.length + 1,
            description1: "",
            field1Type: "",
            field1Value: "",
            derivation: "",
            description2: "",
            field2Type: "",
            field2Value: "",
            linkValueAmount: "0.00",
            total: true,
            totalAmount: "0.00",
            value1: "",
            derivationOperator: "",
            value2: ""
        };
        setRows([...rows, newRow]);
    };

    const handleTotalChange = (rowId) => {
        setRows(rows.map(row => {
            if (row.id === rowId) {
                return {
                    ...row,
                    total: !row.total
                };
            }
            return row;
        }));
    };

    const handleRemoveRow = (rowId) => {
        if (rows.length > 1) {
            setRows(rows.filter(row => row.id !== rowId));
        }
    };

    const handleSavePopup = () => {
        setRows(rows.map(row => {
            if (row.id === selectedRow.id) {
                // Calculate link value before saving
                const value1 = parseFloat(selectedRow.field1Value) || 0;
                const value2 = parseFloat(selectedRow.field2Value) || 0;
                let linkValue = 0;

                switch (selectedRow.derivationOperator) {
                    case '+':
                        linkValue = value1 + value2;
                        break;
                    case '-':
                        linkValue = value1 - value2;
                        break;
                    case '*':
                        linkValue = value1 * value2;
                        break;
                    case '/':
                        linkValue = value2 !== 0 ? value1 / value2 : 0;
                        break;
                    default:
                        linkValue = 0;
                }

                // Create the updated row with all necessary fields
                const updatedRow = {
                    ...selectedRow,
                    value1: value1.toFixed(2),
                    value2: value2.toFixed(2),
                    linkValueAmount: linkValue.toFixed(2)
                };

                // Preserve the element data if it exists
                if (selectedRow.field1Type === "element") {
                    updatedRow.element1 = selectedRow.element1;
                    updatedRow.costType1 = selectedRow.costType1;
                }

                if (selectedRow.field2Type === "element") {
                    updatedRow.element2 = selectedRow.element2;
                    updatedRow.costType2 = selectedRow.costType2;
                }

                return updatedRow;
            }
            return row;
        }));
        setIsPopupOpen(false);
    };

    const handlePopupChange = (field, value) => {
        setSelectedRow(prev => {
            const updatedRow = {
                ...prev,
                [field]: value
            };

            if (field === 'element1' && value) {
                loadCostTypeSuggestions(value.value, 1);
                // Reset cost type when changing element
                updatedRow.costType1 = null;
                // Find the selected element in options to get its value
                updatedRow.field1Value = "1";
                updatedRow.value1 = "1";
            }

            // Handle costType1 selection
            if (field === 'costType1' && value) {
                // Find the selected cost type in options to get its value
                const selectedCostType = selectedRow.costType1Options?.find(opt => opt.value === value);
                if (selectedCostType && selectedCostType.costTypeValue) {
                    updatedRow.field1Value = selectedCostType.costTypeValue;
                    updatedRow.value1 = selectedCostType.costTypeValue;
                }
            }

            // Handle element2 selection
            if (field === 'element2' && value) {
                loadCostTypeSuggestions(value.value, 2);
                // Reset cost type when changing element
                updatedRow.costType2 = null;
                // Find the selected element in options to get its value
               updatedRow.field2Value = "1";
                updatedRow.value2 = "1";
            }

            // Handle costType2 selection
            if (field === 'costType2' && value) {
                // Find the selected cost type in options to get its value
                const selectedCostType = selectedRow.costType2Options?.find(opt => opt.value === value);
                if (selectedCostType && selectedCostType.costTypeValue) {
                    updatedRow.field2Value = selectedCostType.costTypeValue;
                    updatedRow.value2 = selectedCostType.costTypeValue;
                }
            }

            // Recalculate values when relevant fields change
            if (field === 'field1Type' || field === 'field1Value' || field === 'linkField1' ||
                field === 'field2Type' || field === 'field2Value' || field === 'linkField2' ||
                field === 'derivationOperator') {

                // Calculate value1
                let value1 = 0;
                if (updatedRow.field1Type === "Numeric") {
                    value1 = parseFloat(updatedRow.field1Value) || 0;
                } else if (updatedRow.field1Type === "link") {
                    const linkedRow = rows.find(r => r.description1 === updatedRow.linkField1);
                    value1 = linkedRow ? parseFloat(linkedRow.linkValueAmount) || 0 : 0;
                    updatedRow.field1Value = value1.toString();
                }
                else if (updatedRow.field1Type === "element") {
                    value1 = parseFloat(updatedRow.field1Value) || 0;
                }

                // Calculate value2
                let value2 = 0;
                if (updatedRow.field2Type === "Numeric") {
                    value2 = parseFloat(updatedRow.field2Value) || 0;
                } else if (updatedRow.field2Type === "link") {
                    const linkedRow = rows.find(r => r.description1 === updatedRow.linkField2);
                    value2 = linkedRow ? parseFloat(linkedRow.linkValueAmount) || 0 : 0;
                    updatedRow.field2Value = value2.toString();
                } else if (updatedRow.field2Type === "element") {
                    value2 = parseFloat(updatedRow.field2Value) || 0;
                }

                // Calculate link value
                let linkValue = 0;
                switch (updatedRow.derivationOperator) {
                    case '+':
                        linkValue = value1 + value2;
                        break;
                    case '-':
                        linkValue = value1 - value2;
                        break;
                    case '*':
                        linkValue = value1 * value2;
                        break;
                    case '/':
                        linkValue = value2 !== 0 ? value1 / value2 : 0;
                        break;
                    default:
                        linkValue = 0;
                }

                updatedRow.value1 = value1.toFixed(2);
                updatedRow.value2 = value2.toFixed(2);
                updatedRow.linkValueAmount = linkValue.toFixed(2);
                
            }

            return updatedRow;
        });
    };

    const [navigationData, setNavigationData] = useState(null);

    useEffect(() => {
        const storedData = sessionStorage.getItem("subcostNavigationData");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setNavigationData(parsed);

            // Only use the rows for the current field
            const initialRows = parsed.field === 'quantity'
                ? (parsed.element.quantitySetup || [])
                : (parsed.element.rateSetup || []);

            setRows(initialRows.length ? initialRows : [{
                id: 1,
                description1: "",
                field1Type: "",
                field1Value: "",
                derivation: "",
                description2: "",
                field2Type: "",
                field2Value: "",
                linkValueAmount: "0.00",
                total: true,
                totalAmount: "0.00",
                value1: "",
                derivationOperator: "",
                value2: ""
            }]);

            setCostElementName(
                parsed.field === "quantity"
                    ? `${parsed.element.element} (Quantity)`
                    : `${parsed.element.element} (Rate)`
            );
        }
    }, []);


    const handleSubcostlineSubmit = () => {
        if (!navigationData) return;

        const returnData = {
            ...navigationData,
            calculatedValue: totalAmount,
            rows,
            element: {
                ...navigationData.element,
                [navigationData.field === "quantity" ? "quantity_setup" : "rate_setup"]: rows
            }
        };

        try {
            sessionStorage.setItem("subcostReturnData", JSON.stringify(returnData));
            console.log('Stored return data:', returnData);
        } catch (err) {
            console.error("❌ Error handling subcost submit:", err);
        }
        setTimeout(() => navigate(-1), 300);
    };



    return (
        <>
            <Header />
            <div className='sub-costline'>
                <div className='sub-costline-header'>
                    <div className='sub-costline-header-left'>
                        <img src={back_arrow} alt="" onClick={() => navigate(-1)}
                            style={{ cursor: "pointer" }} />
                        <p className="new_cost_line">Sub Cost Line</p>
                    </div>
                    <div className='sub-costline-header-right'>
                        <button className="cancel_btn" onClick={() => navigate(-1, {
                            state: {
                                fieldName: 'quantity',
                                fieldValue: totalAmount,
                            },
                        })}>Cancel</button>
                        {/* <button className="save_btn" onClick={handleSubcostlineSubmit}>
                            Submit
                        </button> */}
                    </div>
                </div>

                <div className="subcost-table-container">
                    <h2 className="sub-costline-table-title">SUB - COST LINES</h2>

                    <div className="element-name-container">
                        <label htmlFor="sub-costline-costElement">Cost Element Name (Qty/Rate)</label>
                        <input
                            id="costElement"
                            value={costElementName}
                            readOnly
                            style={{backgroundColor: '#F6F6F6' }}
                            onChange={(e) => setCostElementName(e.target.value)}
                            className="element-name-input"
                            placeholder="Enter cost element name"
                        />
                    </div>

                    <div className="sub-costline-total-display">
                        <span>TOTAL = </span>
                        <span className="sub-costline-total-value">{totalAmount}</span>
                    </div>

                    <div className="table-subcostline-container" style={{ overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth' }}>
                        <table className="sub-costline-cost-table">
                            <thead>
                                <tr>
                                    <th className="text-label-column">DESCRIPTION</th>
                                    <th className="field-column" colSpan="4">FIELD 1</th>
                                    <th className="derivation-column">DERIVATION</th>
                                    <th className="text-label-column">DESCRIPTION</th>
                                    <th className="field-column" colSpan="4">FIELD 2</th>
                                    <th className="checkbox-column">LINK VALUE</th>
                                    <th className="checkbox-column">TOTAL</th>
                                </tr>
                            </thead>

                            <tbody>
                                {rows.map((row) => (
                                    <tr key={row.id} style={{ position: "relative" }} onClick={() => handleRowClick(row)}
                                        className="subcostline-row-clickable-row">
                                        <td>{row.description1}</td>

                                        <td className="field1-subcol">{row.field1Type}</td>
                                        <td className="field1-subcol">{row.field1Value}</td>
                                        <td className="field1-subcol">{row.linkField1}</td>
                                        <td className="field1-subcol">{row.field1Value}</td>

                                        <td>{row.derivationOperator}</td>
                                        <td>{row.description2}</td>

                                        <td className="field2-subcol">{row.field2Type}</td>
                                        <td className="field2-subcol">{row.field2Value}</td>
                                        <td className="field1-subcol">{row.linkField2}</td>
                                        <td className="field1-subcol">{row.field1Value}</td>

                                        <td className="sub-costline-checkbox-cell">
                                            <span className="link-value" onClick={handleStopPropagation}>
                                                {row.linkValueAmount}
                                            </span>
                                        </td>

                                        <td className="checkbox-cell total-cell">
                                            <div className="total-checkbox-container" onClick={handleStopPropagation}>
                                                <input
                                                    type="checkbox"
                                                    readOnly
                                                    checked={row.total}
                                                    onChange={(e) => {
                                                        handleStopPropagation(e);
                                                        handleTotalChange(row.id);
                                                    }}
                                                    className="checkbox"
                                                />
                                                <span className="sub-costline-total-value">
                                                    {row.linkValueAmount}
                                                </span>
                                            </div>
                                        </td>

                                        <td
                                            style={{
                                                position: "absolute",
                                                right: "-60px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                border: "none",
                                            }}
                                        >
                                            <img
                                                src={delete_icon}
                                                onClick={(e) => {
                                                    handleStopPropagation(e);
                                                    handleRemoveRow(row.id);
                                                }}
                                                className="remove-icon"
                                                style={{ cursor: "pointer" }}
                                                title="Remove Row"
                                                alt=""
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* <div
                        className="add_new_row"
                        onClick={handleAddRow}
                        style={{ cursor: "pointer" }}
                    >
                        <span className="add_new_row_popup">
                            <img src={plus_icon} alt="" />
                            Add Row
                        </span>
                    </div> */}
                </div>

                {isPopupOpen && selectedRow && (
                    <div className="subcostline-row-details-popup">
                        <div className="subcostline-row-popup-content">
                            <div className="subcostline-row-popup-header">
                                <h3>Row Details</h3>
                                <button
                                    className="subcostline-row-close-popup"
                                    onClick={handleClosePopup}
                                >
                                    ×
                                </button>
                            </div>

                            <div className="subcostline-row-popup-grid">
                                <div className="subcostline-row-popup-section description-section">
                                    <label className='subcostline-row-popup-label'>Description 1</label>
                                    <input
                                        type="text"
                                        value={selectedRow.description1}
                                        readOnly
                                        onChange={(e) => handlePopupChange('description1', e.target.value)}
                                        style={{
                                            padding: '8px 10px',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px',
                                            fontSize: '13px',
                                            width: '100%',
                                            boxSizing: 'border-box',
                                            margin: '0px',
                                            backgroundColor: '#F6F6F6' 
                                        }}
                                    />
                                </div>

                                <div className="subcostline-row-popup-section type-section">
                                    <div className="subcostline-row-field-group">
                                        <label className='subcostline-row-popup-label'>Type 1</label>
                                        <select
                                            value={selectedRow.field1Type}
                                            disabled
                                            onChange={(e) => handlePopupChange('field1Type', e.target.value)}
                                            style={{
                                                padding: '8px 10px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                fontSize: '13px',
                                                width: '100%',
                                                boxSizing: 'border-box',
                                                margin: '0px',
                                                textAlign: 'center',
                                                backgroundColor: '#F6F6F6' 
                                            }}
                                        >
                                            <option value=""></option>
                                            <option value="Numeric">Numeric</option>
                                            <option value="element">Element</option>
                                            <option value="link">Link</option>
                                        </select>
                                    </div>

                                    {selectedRow.field1Type === "element" && (
                                        <>
                                            <div className="subcostline-row-field-group">
                                                <label className='subcostline-row-popup-label'>Element 1</label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    defaultOptions
                                                    isDisabled={true}
                                                    loadOptions={loadElementOptions1}
                                                    onChange={(selected) => handlePopupChange('element1', selected)}
                                                    value={selectedRow.element1}
                                                    getOptionValue={(option) => option.value}
                                                    getOptionLabel={(option) => option.label}
                                                    placeholder="Search element..."
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            minHeight: '30px',
                                                            fontSize: '13px',
                                                            backgroundColor: '#F6F6F6' 
                                                        }),
                                                        dropdownIndicator: (base) => ({
                                                            ...base,
                                                            padding: '4px'
                                                        }),
                                                        clearIndicator: (base) => ({
                                                            ...base,
                                                            padding: '4px'
                                                        }),
                                                        menu: (base) => ({
                                                            ...base,
                                                            fontSize: '11px',
                                                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                                                        }),
                                                        placeholder: (base) => ({
                                                            ...base,
                                                            color: '#999',
                                                            fontSize: '10px',
                                                            margin: 0,
                                                            position: 'absolute',
                                                            top: '50%',
                                                            transform: 'translateY(-50%)'
                                                        }),
                                                    }}
                                                />
                                            </div>
                                            <div className="subcostline-row-field-group">
                                                <label className='subcostline-row-popup-label'>Cost Type 1</label>
                                                <select
                                                    value={selectedRow.costType1 || ''}
                                                    onChange={(e) => handlePopupChange('costType1', e.target.value)}
                                                    className="subcostline-row-element-select" disabled style={{ backgroundColor: "#f5f5f5" }}
                                                >
                                                    <option value="">Select cost type</option>
                                                    {selectedRow.costType1Options?.map(option => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="subcostline-row-field-group">
                                                <label className='subcostline-row-popup-label'>Field Value 1</label>
                                                <input
                                                    type="number"
                                                    value={selectedRow.field1Value}
                                                    readOnly
                                                    onChange={(e) => handlePopupChange('field1Value', e.target.value)}
                                                    style={{
                                                        padding: '8px 10px',
                                                        border: '1px solid #ddd',
                                                        borderRadius: '4px',
                                                        fontSize: '13px',
                                                        width: '100%',
                                                        boxSizing: 'border-box',
                                                        margin: '0px',
                                                        backgroundColor: '#F6F6F6' 
                                                    }}
                                                />
                                            </div>
                                        </>
                                    )}



                                    {selectedRow.field1Type === "link" && (
                                        <>
                                            <div className="subcostline-row-field-group">
                                                <label className='subcostline-row-popup-label'>Link Field</label>
                                                <select
                                                    value={selectedRow.linkField1 || ''}
                                                    disabled
                                                    onChange={(e) => handlePopupChange('linkField1', e.target.value)}
                                                    style={{
                                                        padding: '8px 10px',
                                                        border: '1px solid #ddd',
                                                        borderRadius: '4px',
                                                        fontSize: '13px',
                                                        width: '100%',
                                                        boxSizing: 'border-box',
                                                        margin: '0px',
                                                        backgroundColor: '#F6F6F6' 
                                                    }}
                                                >
                                                    <option value="">Select a link</option>
                                                    {rows
                                                        .filter(row => row.id !== selectedRow.id && row.description1)
                                                        .map(row => (
                                                            <option key={row.id} value={row.description1}>
                                                                {row.description1}
                                                            </option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                            <div className="subcostline-row-field-group">
                                                <label className='subcostline-row-popup-label'>Field Value 1</label>
                                                <div
                                                    style={{
                                                        padding: '8px 10px',
                                                        border: '1px solid #ddd',
                                                        borderRadius: '4px',
                                                        fontSize: '13px',
                                                        width: '100%',
                                                        backgroundColor: '#f5f5f5',
                                                        margin: '0px',
                                                        boxSizing: 'border-box',
                                                    }}
                                                >
                                                    {
                                                        rows.find(row => row.description1 === selectedRow.linkField1)?.linkValueAmount || ''
                                                    }
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    {selectedRow.field1Type === "Numeric" && (
                                        <div className="subcostline-row-field-group">
                                            <label className='subcostline-row-popup-label'>Field Value 1</label>
                                            <input
                                                type="number"
                                                readOnly
                                                value={selectedRow.field1Value}
                                                onChange={(e) => handlePopupChange('field1Value', e.target.value)}
                                                style={{
                                                    padding: '8px 10px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '4px',
                                                    fontSize: '13px',
                                                    width: '100%',
                                                    boxSizing: 'border-box',
                                                    margin: '0px',
                                                     backgroundColor: '#F6F6F6' 
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>

                                <div className="subcostline-row-popup-section description-section">
                                    <label className='subcostline-row-popup-label'>Description 2</label>
                                    <input
                                        type="text"
                                        readOnly
                                        value={selectedRow.description2}
                                        onChange={(e) => handlePopupChange('description2', e.target.value)}
                                        style={{
                                            padding: '8px 10px',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px',
                                            fontSize: '13px',
                                            width: '100%',
                                            boxSizing: 'border-box',
                                            margin: '0px',
                                             backgroundColor: '#F6F6F6' 
                                        }}
                                    />
                                </div>

                                <div className="subcostline-row-popup-section type-section">
                                    <div className="subcostline-row-field-group">
                                        <label className='subcostline-row-popup-label'>Type 2</label>
                                        <select
                                            value={selectedRow.field2Type}
                                            disabled
                                            onChange={(e) => handlePopupChange('field2Type', e.target.value)}
                                            style={{
                                                padding: '8px 10px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                fontSize: '13px',
                                                width: '100%',
                                                boxSizing: 'border-box',
                                                margin: '0px',
                                                backgroundColor: '#F6F6F6' ,
                                                textAlign: 'center'
                                            }}
                                        >
                                            <option value=""></option>
                                            <option value="Numeric">Numeric</option>
                                            <option value="element">Element</option>
                                            <option value="link">Link</option>
                                        </select>
                                    </div>

                                    {selectedRow.field2Type === "element" && (
                                        <>
                                            <div className="subcostline-row-field-group">
                                                <label className='subcostline-row-popup-label'>Element 2</label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    defaultOptions
                                                    isDisabled ={true}
                                                    loadOptions={loadElementOptions2}
                                                    onChange={(selected) => handlePopupChange('element2', selected)}
                                                    value={selectedRow.element2}
                                                    getOptionValue={(option) => option.value}  // Ensure we track the full option
                                                    getOptionLabel={(option) => option.label}
                                                    placeholder="Search element..."
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            minHeight: '30px',
                                                            fontSize: '13px',
                                                            backgroundColor: '#F6F6F6' 
                                                        }),
                                                        dropdownIndicator: (base) => ({
                                                            ...base,
                                                            padding: '4px'
                                                        }),
                                                        clearIndicator: (base) => ({
                                                            ...base,
                                                            padding: '4px'
                                                        }),
                                                        menu: (base) => ({
                                                            ...base,
                                                            fontSize: '11px',
                                                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                                                        }),
                                                        placeholder: (base) => ({
                                                            ...base,
                                                            color: '#999',
                                                            fontSize: '10px',
                                                            margin: 0,
                                                            position: 'absolute',
                                                            top: '50%',
                                                            transform: 'translateY(-50%)'
                                                        }),
                                                    }}
                                                />
                                            </div>
                                            <div className="subcostline-row-field-group">
                                                <label className='subcostline-row-popup-label'>Cost Type 2</label>
                                                <select
                                                    value={selectedRow.costType2 || ''}
                                                    disabled
                                                    style={{ backgroundColor: "#f5f5f5" }}
                                                    onChange={(e) => handlePopupChange('costType2', e.target.value)}
                                                    className="subcostline-row-element-select"
                                                >
                                                    <option value="">Select cost type</option>
                                                    {selectedRow.costType2Options?.map(option => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="subcostline-row-field-group">
                                                <label className='subcostline-row-popup-label'>Field Value 2</label>
                                                <input
                                                    type="number"
                                                    readOnly
                                                    value={selectedRow.field2Value}
                                                    onChange={(e) => handlePopupChange('field2Value', e.target.value)}
                                                    style={{
                                                        padding: '8px 10px',
                                                        border: '1px solid #ddd',
                                                        borderRadius: '4px',
                                                        fontSize: '13px',
                                                        width: '100%',
                                                        boxSizing: 'border-box',
                                                        margin: '0px' ,
                                                         backgroundColor: '#F6F6F6' 
                                                    }}
                                                />
                                            </div>
                                        </>
                                    )}

                                    {selectedRow.field2Type === "link" && (
                                        <>
                                            <div className="subcostline-row-field-group">
                                                <label className='subcostline-row-popup-label'>Link Field</label>
                                                <select
                                                    value={selectedRow.linkField2 || ''}
                                                    disabled
                                                    onChange={(e) => handlePopupChange('linkField2', e.target.value)}
                                                    style={{
                                                        padding: '8px 10px',
                                                        border: '1px solid #ddd',
                                                        borderRadius: '4px',
                                                        fontSize: '13px',
                                                        width: '100%',
                                                        boxSizing: 'border-box',
                                                        margin: '0px',
                                                         backgroundColor: '#F6F6F6' 
                                                    }}
                                                >
                                                    <option value="">Select a link</option>
                                                    {rows
                                                        .filter(row => row.id !== selectedRow.id && row.description2)
                                                        .map(row => (
                                                            <option key={row.id} value={row.description2}>
                                                                {row.description2}
                                                            </option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                            <div className="subcostline-row-field-group">
                                                <label className='subcostline-row-popup-label'>Field Value 2</label>
                                                <input
                                                    style={{
                                                        padding: '8px 10px',
                                                        border: '1px solid #ddd',
                                                        borderRadius: '4px',
                                                        fontSize: '13px',
                                                        width: '100%',
                                                        backgroundColor: '#f5f5f5',
                                                        margin: '0px',
                                                        boxSizing: 'border-box',
                                                    }}
                                                    readOnly
                                                    value={
                                                        rows.find(row => row.description2 === selectedRow.linkField2)?.linkValueAmount || ''
                                                    }
                                                />
                                            </div>
                                        </>
                                    )}

                                    {selectedRow.field2Type === "Numeric" && (
                                        <div className="subcostline-row-field-group">
                                            <label className='subcostline-row-popup-label'>Field Value 2</label>
                                            <input
                                                type="number"
                                                readOnly
                                                value={selectedRow.field2Value}
                                                onChange={(e) => handlePopupChange('field2Value', e.target.value)}
                                                style={{
                                                    padding: '8px 10px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '4px',
                                                    fontSize: '13px',
                                                    width: '100%',
                                                    boxSizing: 'border-box',
                                                    margin: '0px',
                                                     backgroundColor: '#F6F6F6' 
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>

                                <div className="popup-section total-section">
                                    <div className="total-grid">
                                        <div className="subcostline-row-popup-total-field">
                                            <label className='subcostline-row-popup-label'>Value 1</label>
                                            <input
                                                type="text"
                                                value={selectedRow.value1}
                                                readOnly
                                                style={{
                                                    padding: '8px 10px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '4px',
                                                    fontSize: '13px',
                                                    width: '100%',
                                                    boxSizing: 'border-box',
                                                    margin: '0px',
                                                    backgroundColor: '#f5f5f5'
                                                }}
                                            />
                                        </div>
                                        <div className="subcostline-row-popup-total-field">
                                            <label className='subcostline-row-popup-label'>Derivation</label>
                                            <select
                                            disabled
                                                value={selectedRow.derivationOperator}
                                                onChange={(e) => handlePopupChange('derivationOperator', e.target.value)}
                                                style={{
                                                    padding: '8px 10px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '4px',
                                                    fontSize: '13px',
                                                    width: '100%',
                                                    boxSizing: 'border-box',
                                                    margin: '0px',
                                                    backgroundColor: '#F6F6F6', 
                                                    textAlign: 'center',
                                                }}
                                            >
                                                <option value=""></option>
                                                <option value="+">+</option>
                                                <option value="-">-</option>
                                                <option value="*">*</option>
                                                <option value="/">/</option>
                                            </select>
                                        </div>
                                        <div className="subcostline-row-popup-total-field">
                                            <label className='subcostline-row-popup-label'>Value 2</label>
                                            <input
                                                type="text"
                                                value={selectedRow.value2}
                                                readOnly
                                                style={{
                                                    padding: '8px 10px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '4px',
                                                    fontSize: '13px',
                                                    width: '100%',
                                                    boxSizing: 'border-box',
                                                    margin: '0px',
                                                    backgroundColor: '#f5f5f5'
                                                }}
                                            />
                                        </div>
                                        <div className="subcostline-row-popup-total-field">
                                            <label className='subcostline-row-popup-label'>Link value</label>
                                            <input
                                                type="text"
                                                value={selectedRow.linkValueAmount}
                                                readOnly
                                                style={{
                                                    padding: '8px 10px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '4px',
                                                    fontSize: '13px',
                                                    width: '100%',
                                                    boxSizing: 'border-box',
                                                    margin: '0px',
                                                    backgroundColor: '#f5f5f5'
                                                }}
                                            />
                                        </div>
                                        <div className="subcostline-row-popup-total-field total-checkbox-field">
                                            <label className='subcostline-row-popup-label checkbox-label'>
                                                <input
                                                    type="checkbox"
                                                    readOnly
                                                    checked={selectedRow.total}
                                                    onChange={(e) => handlePopupChange('total', e.target.checked)}
                                                    style={{ marginRight: '5px', backgroundColor: '#F6F6F6'  }}
                                                />
                                                Total
                                            </label>
                                            <input
                                                type="text"
                                                value={selectedRow.linkValueAmount}
                                                readOnly
                                                style={{
                                                    padding: '8px 10px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '4px',
                                                    fontSize: '13px',
                                                    width: '100%',
                                                    boxSizing: 'border-box',
                                                    margin: '0px',
                                                    backgroundColor: '#f5f5f5'
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <CommonFooter />
        </>
    );
};

export default SubCostlineViewPage
